import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PecaService {
 	private data = null;
	private url = environment.serviceApi;
 	constructor(public http: Http) { }

  	getPecas(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/peca' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getPeca(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/peca/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaPeca(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/peca', {
				peca_nome: data.peca_nome,
				peca_validade: data.peca_validade,
				peca_quilometragem: data.peca_quilometragem,	
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaPeca(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/peca/' + data.peca_id, {
				peca_nome: data.peca_nome,
				peca_validade: data.peca_validade,
				peca_quilometragem: data.peca_quilometragem,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaPeca(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/peca/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
